import { createFileRoute } from "@tanstack/react-router"
import { ProPage } from "@/components/pages/ProPage"
import { defaultMeta } from "@/lib/seo"

export const Route = createFileRoute(`/_public/pro`)({
  ssr: true,
  head: () =>
    defaultMeta({
      title: `ChicTravel Pro`,
      description: `Unlock ChicTravel Pro — automated ChicReview trip audits, polished PDF exports, calendar (.ics) exports, and AI context exports. Start a free trial.`,
      path: `/pro`,
    }),
  component: ProPage,
})
